<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-dialog-content class="mat-typography">
    <h3>Are you sure you want to delete this file?</h3>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="cancel()">No</button>
    <button mat-button [mat-dialog-close]="true">Yes</button>
</mat-dialog-actions>
